import { render, staticRenderFns } from "./CreatorColumns.vue?vue&type=template&id=495b8ded&scoped=true"
import script from "./CreatorColumns.vue?vue&type=script&lang=js"
export * from "./CreatorColumns.vue?vue&type=script&lang=js"
import style0 from "./CreatorColumns.vue?vue&type=style&index=0&id=495b8ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b8ded",
  null
  
)

export default component.exports